import React, { useEffect, useState } from 'react';
import styles from './ResourceSharing.module.scss';
import { JumboBanner } from 'new/elements/JumboBanner';
import { PlayArrowRounded } from '@mui/icons-material';
import { ResourceSearchBanner } from 'new/elements/ResourceSearchBanner';
import { ScreenComponent } from 'new/routes/RouterManager';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_COLLABORATE_360 } from 'new/constants/pathnames';
import { ResourcesTable } from 'new/components/ResourcesTable/ResourcesTable';
import { useResource } from 'new/components/monitor/ResourceTriage/useResource';
import { useHistory } from 'react-router-dom';
import { ResourceDetail } from 'new/components/collaborate/ResourceDetail';
import { CenteredLoader } from 'new/elements/CenteredLoader';

interface Collaboration360Props {}

export const ResourceSharing: ScreenComponent<any> = (props: Collaboration360Props) => {
  const history = useHistory();
  const [data, setData] = useState({ type: '', id: '' });
  const { resource, loading } = useResource(data.type, data.id);
  const onSearch = ({ type, id }) => {
    setData({
      type,
      id,
    });
  };

  useEffect(() => {
    if (resource && resource.id) {
      history.push({
        pathname: ResourceDetail.screenConfig.path,
        search: `?type=${data.type}&id=${resource.id}`,
      });
    }
  }, [resource]);

  return (
    <div className={styles.container}>
      <JumboBanner
        title="Collaborate With Your Team Easily"
        description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla morbi nisl pretium fermentum morbi sem ut turpis. Porttitor tincidunt vivamus in id leo nisi, vitae mi. "
        cta={{
          title: 'Learn More',
          startIcon: <PlayArrowRounded />,
          onClick: () => {},
        }}
      />
      {loading ? <CenteredLoader /> : null}
      <ResourceSearchBanner buttonColor="secondary" onSearch={onSearch} />
      <ResourcesTable />
    </div>
  );
};

ResourceSharing.screenConfig = {
  path: `${ROUTE_REDESIGN}${ROUTE_COLLABORATE_360}`,
  domain: 'collaborate',
  header: {
    title: 'Resource Sharing',
    slugTitle: 'Resource Sharing',
  },
  screenName: 'ResourceSharing',
};
